import request from "@/utils/request";

// 列表(主数据列表)
export function loadPageDataApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/listData",
    method: "post",
    data
  });
}

// 导出
export function exportDataApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/exportData",
    method: "post",
    data
  });
}

// 导出图片zip
export function exportPicZipDataApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/exportPicZip",
    method: "post",
    data
  });
}

// 导出图片zip
export function exportShareQrCodePicZipDataApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/exportShareQrCodePicZip",
    method: "post",
    data
  });
}

// 新增|修改
export function saveOrUpdateApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/saveOrUpdate",
    method: "post",
    data
  });
}

// 作废
export function deleteApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/delete",
    method: "post",
    data
  });
}

// 发布
export function releaseApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/release",
    method: "post",
    data
  });
}

// 撤回
export function revokeApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/revoke",
    method: "post",
    data
  });
}

// 查看
export function initApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/init",
    method: "post",
    data
  });
}

// 查询待审批活动数据采集数量
export function countTodoAuditApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/countTodoAudit",
    method: "post",
    data
  });
}

// 分页查询待审批活动数据采集
export function loadTodoAuditPageDataApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/listTodoAuditData",
    method: "post",
    data
  });
}

// 审批
export function auditApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/audit",
    method: "post",
    data
  });
}

// 审批
export function auditBatchApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/auditBatch",
    method: "post",
    data
  });
}

// 获取用户提交的信息采集数据
export function loadUserCommitDataApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/loadUserCommitData",
    method: "post",
    data
  });
}

// 初始化用户提交的采集数据
export function initInfoDataApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/initInfoData",
    method: "post",
    data
  });
}

// 导出用户提交的采集数据
export function exportUserCommitDataApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/exportUserCommitData",
    method: "post",
    data
  });
}

// 查询扫码兑换的采集数据
export function loadApprovalDataApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/loadApprovalData",
    method: "post",
    data
  });
}

// 导出扫码兑换的采集数据
export function exportApprovalDataApi(data) {
  return request({
    url: "web/appActivityDataAcquisition/exportApprovalData",
    method: "post",
    data
  });
}

// 根据用户和采集主键获取采集明细
export function findApprovalInfoByDataIdAndUserIdApi(data) {
  return request({
    url: "web/appActivityDataAcquisitionApprovalInfo/findInfoByInfoIdAndUserId",
    method: "post",
    data
  });
}
